import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyConverter'
})
export class CurrencyConverterPipe implements PipeTransform {

  transform(value: string): string {
    const currency = value ? value.toLowerCase() : ''
    if (!(currency === "mxp")) {
      return value
    }
    return 'MXN';
  }

}
